// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function address_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var receiver_name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "receiver_name"), null));
  if (receiver_name.TAG === /* Ok */0) {
    var receiver_phone = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "receiver_phone"), null));
    if (receiver_phone.TAG === /* Ok */0) {
      var address_line_1 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "address_line_1"), null));
      if (address_line_1.TAG === /* Ok */0) {
        var address_line_2 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "address_line_2"), null));
        if (address_line_2.TAG === /* Ok */0) {
          var city = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
          if (city.TAG === /* Ok */0) {
            var state = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "state"), null));
            if (state.TAG === /* Ok */0) {
              var postal_code = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "postal_code"), null));
              if (postal_code.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          receiver_name: receiver_name._0,
                          receiver_phone: receiver_phone._0,
                          address_line_1: address_line_1._0,
                          address_line_2: address_line_2._0,
                          city: city._0,
                          state: state._0,
                          postal_code: postal_code._0
                        }
                      };
              }
              var e = postal_code._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".postal_code" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = state._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".state" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = city._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".city" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = address_line_2._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".address_line_2" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = address_line_1._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".address_line_1" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = receiver_phone._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".receiver_phone" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = receiver_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".receiver_name" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function requesterDetails_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var phone = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "phone"), null));
    if (phone.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                phone: phone._0
              }
            };
    }
    var e = phone._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".phone" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function requester_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var user_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "user_id"), null));
  if (user_id.TAG === /* Ok */0) {
    var persona = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "persona"), null));
    if (persona.TAG === /* Ok */0) {
      var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        var phone = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "phone"), null));
        if (phone.TAG === /* Ok */0) {
          var details = Decco.optionFromJson(requesterDetails_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "details"), null));
          if (details.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      user_id: user_id._0,
                      persona: persona._0,
                      name: name._0,
                      phone: phone._0,
                      details: details._0
                    }
                  };
          }
          var e = details._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".details" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = phone._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".phone" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = persona._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".persona" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = user_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".user_id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function product_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        var is_active = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
        if (is_active.TAG === /* Ok */0) {
          var image_url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "image_url"), null));
          if (image_url.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      code: code._0,
                      name: name._0,
                      description: description._0,
                      is_active: is_active._0,
                      image_url: image_url._0
                    }
                  };
          }
          var e = image_url._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".image_url" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = is_active._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_active" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function variant_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var sku = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sku"), null));
  if (sku.TAG === /* Ok */0) {
    var size_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "size_code"), null));
    if (size_code.TAG === /* Ok */0) {
      var is_active = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
      if (is_active.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  sku: sku._0,
                  size_code: size_code._0,
                  is_active: is_active._0
                }
              };
      }
      var e = is_active._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".is_active" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = size_code._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".size_code" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = sku._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".sku" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function item_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_id"), null));
  if (order_id.TAG === /* Ok */0) {
    var product = product_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "product"), null));
    if (product.TAG === /* Ok */0) {
      var variant = variant_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "variant"), null));
      if (variant.TAG === /* Ok */0) {
        var quantity = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "quantity"), null));
        if (quantity.TAG === /* Ok */0) {
          var unit_price_minor = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "unit_price_minor"), null));
          if (unit_price_minor.TAG === /* Ok */0) {
            var total_price_minor = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_price_minor"), null));
            if (total_price_minor.TAG === /* Ok */0) {
              var currency_code = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency_code"), null));
              if (currency_code.TAG === /* Ok */0) {
                var created_at = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
                if (created_at.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            order_id: order_id._0,
                            product: product._0,
                            variant: variant._0,
                            quantity: quantity._0,
                            unit_price_minor: unit_price_minor._0,
                            total_price_minor: total_price_minor._0,
                            currency_code: currency_code._0,
                            created_at: created_at._0
                          }
                        };
                }
                var e = created_at._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".created_at" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = currency_code._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".currency_code" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = total_price_minor._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".total_price_minor" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = unit_price_minor._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".unit_price_minor" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = quantity._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".quantity" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = variant._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".variant" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = product._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".product" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = order_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_id" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_uuid = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_uuid"), null));
  if (order_uuid.TAG === /* Ok */0) {
    var order_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_number"), null));
    if (order_number.TAG === /* Ok */0) {
      var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
      if (status.TAG === /* Ok */0) {
        var crm_status = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "crm_status"), null));
        if (crm_status.TAG === /* Ok */0) {
          var geo_region_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
          if (geo_region_id.TAG === /* Ok */0) {
            var total_amount_minor = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_amount_minor"), null));
            if (total_amount_minor.TAG === /* Ok */0) {
              var currency_code = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency_code"), null));
              if (currency_code.TAG === /* Ok */0) {
                var customer = Decco.optionFromJson(requester_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer"), null));
                if (customer.TAG === /* Ok */0) {
                  var items = Decco.arrayFromJson(item_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "items"), null));
                  if (items.TAG === /* Ok */0) {
                    var address = {
                      TAG: /* Ok */0,
                      _0: Belt_Option.getWithDefault(Js_dict.get(dict$1, "address"), null)
                    };
                    if (address.TAG === /* Ok */0) {
                      var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
                      if (created_at.TAG === /* Ok */0) {
                        var updated_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updated_at"), null));
                        if (updated_at.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    order_uuid: order_uuid._0,
                                    order_number: order_number._0,
                                    status: status._0,
                                    crm_status: crm_status._0,
                                    geo_region_id: geo_region_id._0,
                                    total_amount_minor: total_amount_minor._0,
                                    currency_code: currency_code._0,
                                    customer: customer._0,
                                    items: items._0,
                                    address: address._0,
                                    created_at: created_at._0,
                                    updated_at: updated_at._0
                                  }
                                };
                        }
                        var e = updated_at._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".updated_at" + e.path,
                                  message: e.message,
                                  value: e.value
                                }
                              };
                      }
                      var e$1 = created_at._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".created_at" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                              }
                            };
                    }
                    var e$2 = address._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".address" + e$2.path,
                              message: e$2.message,
                              value: e$2.value
                            }
                          };
                  }
                  var e$3 = items._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".items" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                          }
                        };
                }
                var e$4 = customer._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".customer" + e$4.path,
                          message: e$4.message,
                          value: e$4.value
                        }
                      };
              }
              var e$5 = currency_code._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".currency_code" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                      }
                    };
            }
            var e$6 = total_amount_minor._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".total_amount_minor" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = geo_region_id._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".geo_region_id" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
        }
        var e$8 = crm_status._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".crm_status" + e$8.path,
                  message: e$8.message,
                  value: e$8.value
                }
              };
      }
      var e$9 = status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".status" + e$9.path,
                message: e$9.message,
                value: e$9.value
              }
            };
    }
    var e$10 = order_number._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".order_number" + e$10.path,
              message: e$10.message,
              value: e$10.value
            }
          };
  }
  var e$11 = order_uuid._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_uuid" + e$11.path,
            message: e$11.message,
            value: e$11.value
          }
        };
}

export {
  address_decode ,
  requesterDetails_decode ,
  requester_decode ,
  product_decode ,
  variant_decode ,
  item_decode ,
  t_decode ,
  
}
/* No side effect */
